import { styled, Typography } from '@mui/material';

export const BrandSubscriptionTitleTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
  fontSize: '20px',
  fontWeight: 600,
  color: '#000000',
}));
